<template>
    <SOSlotModal
        :modal-title="pageSetting.modal.title"
        :modal-id="pageSetting.modal.id"
        :no-padding="true"
        @close="close"
    >
        <template v-slot:modal-body>
            <div style="max-height: 300px; overflow: scroll">
                <div class="p-x-20 p-y-20" @click="filterByDevice({iddevice: '', nama: '', number: ''})">
                    <div class="d-flex-between-center">
                        <div class="f-semi f-16 f-c-black">Semua perangkat</div>
                        <div>
                            <IconBased width="16" height="16" v-if="selectedWaDevice.iddevice === ''">
                                <template v-slot:icons>
                                    <RadioCheckedBlue/>
                                </template>
                            </IconBased>
                            <IconBased width="16" height="16" v-else>
                                <template v-slot:icons>
                                    <RadioUnChecked/>
                                </template>
                            </IconBased>
                        </div>
                    </div>
                </div>
                <div class="separator"></div>
                <div class="p-x-20 p-y-20" v-for="device in waDevice" @click="filterByDevice(device)">
                    <div class="d-flex-between-center">
                        <div>
                            <div class="f-semi f-16 f-c-black nomore" style="width: 250px">{{ device.nama }}</div>
                            <div class="f-regular f-14 f-c-midgrey">{{ device.country_code + device.number }}</div>
                        </div>
                        <div>
                            <IconBased width="16" height="16" v-if="selectedWaDevice.iddevice === device.iddevice">
                                <template v-slot:icons>
                                    <RadioCheckedBlue/>
                                </template>
                            </IconBased>
                            <IconBased width="16" height="16" v-else>
                                <template v-slot:icons>
                                    <RadioUnChecked/>
                                </template>
                            </IconBased>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </SOSlotModal>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {moduleName} from "./../../store/state"
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import IconBased from "@/modules/wa-autosender/components/iconPack/IconBased";
import RadioCheckedBlue from "@/modules/wa-autosender/components/iconPack/RadioCheckedBlue1616";
import RadioUnChecked from "@/modules/wa-autosender/components/iconPack/RadioUnChecked1616";

export default {
    name: "ModalPilihPerangkat",
    components: {
        SOSlotModal,
        IconBased,
        RadioCheckedBlue,
        RadioUnChecked,
    },
    data() {
        return {
            customerTemp: {},
            pageSetting: {
                modal: {
                    title: "Pilih Perangkat WA",
                    id: "modal-pilih-perangkat-wa"
                },
                btn: {
                    save: {
                        disabled: false,
                        loading: false,
                    }
                }
            },
        }
    },
    mounted() {
        $("#" + this.pageSetting.modal.id).modal("show");
        this.fetchWaDevice()
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
            waDevice: "waDevice",
            selectedWaDevice: "selectedWaDevice"
        })
    },
    methods: {
        ...mapActions({
            fetchWaDevice: `${moduleName}/fetchWaDevice`,
            fetchListHistory: `${moduleName}/fetchListHistory`,
        }),
        async filterByDevice(device) {
            let payload = {
                iddevice: device.iddevice
            }
            await this.$store.commit(`${moduleName}/resetPagination`)
            await this.$store.commit(`${moduleName}/resetListHistory`)
            await this.$store.commit(`${moduleName}/setSelectedWaDevice`, device)
            await this.fetchListHistory(payload)
            this.close()
        },
        close() {
            this.$router.back()
        }
    }
}
</script>